import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from "../../../common";
import { authTokenSelector } from '../../../session';
import { QUESTIONS_API_ENDPOINT } from '../endpoints';
import { updateResourceState } from '../util';

const actions = createActions({
  QUESTIONS: {
    GET: (contentId, query) => ({ contentId, query }),
    API: {
      GET: apiResourceActionCreator('questions')
    }
  }
})

export const apiAction = (authToken, contentId, query) => commonApiActions.authenticated.get(`${QUESTIONS_API_ENDPOINT}${endpointQuery({ ...(query || {}), contentId })}`, authToken, actions.questions.api.get)

export function* getQuestions(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.contentId, action.payload.query));
}

const configuration = {
  name: 'get',
  action: actions,
  sagas: getQuestions,
  reducers: {
    request: (state, action) => updateResourceState(state, 'questions', ({
      isFetching: true
    })),
    success: (state, action) => updateResourceState(state, 'questions', ({
      isFetching: false,
      result: action.payload.questions,
      error: null
    })),
    failed: (state, action) => updateResourceState(state, 'questions', ({
      isFetching: false,
      error: action.payload.error
    }))
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/quiz/configurations/questions/get.js